// extracted by mini-css-extract-plugin
module.exports = {"window":"Window_window__2qg9l","content":"Window_content__1zYp_"};